<template>
  <a-modal
    :wrapClassName="disabeld ? 'ps-see-form-modal' : ''"
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    :ok-text="saveText"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="addYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.addYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
            style="width: 100%"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="发文数量" prop="publicationNum">
          <a-input-number
            v-model="form.publicationNum"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入发文数量"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="点击量" prop="clickNum">
          <a-input-number
            v-model="form.clickNum"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入点击量"
            :disabled="disabeld"
          /> </a-form-model-item
        ><a-form-model-item label="关注人数" prop="focusNum">
          <a-input-number
            v-model="form.focusNum"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入关注人数"
            :disabled="disabeld"
          /> </a-form-model-item
        ><a-form-model-item label="微课开发" prop="smallCourseNum">
          <a-input-number
            v-model="form.smallCourseNum"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入微课开发"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="院校交流学习次数" prop="collegesStudentNum">
          <a-input-number
            v-model="form.collegesStudentNum"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入院校交流学习次数"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="宣传渠道载体" prop="channelCarriers">
          <a-select
            placeholder="请选择宣传渠道载体"
            style="width: 100%"
            mode="multiple"
            @change="addExpertChange"
            v-model="form.channelCarriers"
            :disabled="disabeld"
          >
            <a-select-option
              v-for="item in xcList"
              :value="item.text"
              :key="item.value"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
      
    <script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 15 },
      other: "",
      form: {
        applyId: "",
        addYear: "",
        publicationNum: "",
        clickNum: "",
        focusNum: "",
        smallCourseNum: "",
        collegesStudentNum: "",
        channelCarriers: [],
        channelCarrier: "",
      },
      rules: {
        addYear: [
          {
            required: true,
            message: "请选择年份",
            validator: (rule, value, callback) => {
              if (this.form.addYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            trigger: "change",
          },
        ],
        publicationNum: [
          {
            required: true,
            message: "请输入发文数量",
            trigger: "blur",
          },
        ],
        clickNum: [
          {
            required: true,
            message: "请输入点击量",
            trigger: "blur",
          },
        ],
        focusNum: [
          {
            required: true,
            message: "请输入关注人数",
            trigger: "blur",
          },
        ],
        smallCourseNum: [
          {
            required: true,
            message: "请输入微课开发",
            trigger: "blur",
          },
        ],
        collegesStudentNum: [
          {
            required: true,
            message: "请输入院校交流学习次数",
            trigger: "blur",
          },
        ],
        channelCarriers: [
          {
            required: true,
            message: "请选择宣传渠道载体",
            trigger: "change",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 2,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      disabeld: false,
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
      xcList: [],
    };
  },
  components: { BaseEditor },
  mounted() {
    console.log("111111");
    console.log(this.rules);
  },
  methods: {
    addExpertChange() {
      // 多个选择器的值用逗号隔开
      if (this.form.channelCarriers.length > 0) {
        this.form.channelCarrier = this.form.channelCarriers.join(",");
      } else {
        this.form.channelCarrier = "";
      }
    },
    blurValue() {
      if (this.form.amount == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
    },
    handleChange() {
      console.log(this.form.achievementType);
      if (this.form.achievementType == "SZKC") {
        this.ishow = true;
      } else {
        this.ishow = false;
        this.form.courseType = "";
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.addYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      const year = moment(value).format("YYYY");
      this.form.addYear = year + "";
      this.yearShowOne = false;
      // this.form.addYear = value;
      this.$refs.ruleForm.clearValidate("addYear");
      // this.yearShowOne = false;
    },
    getxclist() {
      getAction("/baseCommon/getDictItemsByCode?code=channel_carrier").then(
        (res) => {
          if (res.code == 200) {
            console.log(res, "4444");
            this.xcList = res.result;
          }
        }
      );
    },
    init(type, record, taskId, detailId) {
      this.type = type;
      this.visible = true;
      this.getxclist();
      if (type == "add") {
        //this.form = {};
        this.form.applyId = record.id;
        this.title = "新增品牌宣传";
        this.form.addYear = new Date().getFullYear() + "";
        this.form.channelCarriers = [];
        this.form.channelCarrier = "";
      } else if (type == "edit") {
        this.title = "编辑品牌宣传";
        this.form = {
          addYear: record.addYear,
          publicationNum: record.publicationNum,
          clickNum: record.clickNum,
          focusNum: record.focusNum,
          smallCourseNum: record.smallCourseNum,
          collegesStudentNum: record.collegesStudentNum,
          applyId: record.applyId,
          id: record.id,
          channelCarrier: record.channelCarrier,
          channelCarriers: record.channelCarrier
            ? record.channelCarrier.split(",")
            : [],
        };
        this.teacherdata = record;
      } else if (type === "audit-edit") {
        this.title = "编辑品牌宣传";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        // 合并所有字段，确保编辑时能正确显示原有数据
        this.form = {
          addYear: record.addYear,
          publicationNum: record.publicationNum,
          clickNum: record.clickNum,
          focusNum: record.focusNum,
          smallCourseNum: record.smallCourseNum,
          collegesStudentNum: record.collegesStudentNum,
          applyId: record.applyId,
          id: record.id,
          channelCarrier: record.channelCarrier,
          channelCarriers: record.channelCarrier
            ? record.channelCarrier.split(",")
            : [],
        };
      } else {
        this.disabeld = true;
        this.title = "查看品牌宣传";
        this.saveText = "关闭";
        this.form = {
          addYear: record.addYear,
          publicationNum: record.publicationNum,
          clickNum: record.clickNum,
          focusNum: record.focusNum,
          smallCourseNum: record.smallCourseNum,
          collegesStudentNum: record.collegesStudentNum,
          applyId: record.applyId,
          id: record.id,
          channelCarrier: record.channelCarrier,
          channelCarriers: record.channelCarrier
            ? record.channelCarrier.split(",")
            : [],
        };
      }
    },
    handleCancel() {
      this.visible = false;
      //     this.yearShowOne = false;
    },
    submit() {
      if (this.disabeld) {
        this.visible = false;
        return;
      }
      //  	this.$refs.ruleForm.clearValidate();
      console.log(typeof this.form.addYear);
      if (
        typeof this.form.addYear == "object" &&
        this.form.addYear != "" &&
        this.type == "add"
      ) {
        this.form.addYear = new Date(this.form.addYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        //    	console.log(valid);
        if (valid) {
          //					this.yearShowOne = false;
          if (this.type == "add") {
            let params = this.form;
            //          params.addYear=new Date(this.form.addYear).getFullYear()+"";
            params.applyType = this.applyType;
            //params.applyId = "1829722136428707841";
            postAction("/promotion/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addPropaganda");
              } else {
                this.$message.error(res.message);
              }
            });
          } else if (this.type == "audit-edit") {
            let params = {
              taskId: this.taskId,
              afterJson: JSON.stringify({ ...this.form }),
              detailId: this.detailId,
            };
            postAction("/audit/lxAuditTask/reSubmitTask", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success(res.message || "编辑成功");
                  this.$emit("addPropaganda");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            if (
              this.teacherdata?.status == "0" ||
              this.teacherdata?.status == "1" ||
              this.teacherdata?.status == "4" ||
              this.teacherdata?.status == "3" ||
              (this.teacherdata?.status == "2" && this.teacherdata?.operation)
            ) {
              let params1 = this.form;
              //params.applyId = "1829722136428707841";
              if (typeof this.form.addYear == "object") {
                params1.addYear =
                  new Date(this.form.addYear).getFullYear() + "";
              }
              params1.applyType = this.applyType;
              let params = {
                id: this.teacherdata?.taskId,
                applicationData: JSON.stringify(this.$nullToEmpty(params1)),
              };
              if (this.teacherdata?.status == "4") {
                params.auditState = "1";
              }
              putAction("/audit/lxAuditTask/editTaskAndDetail", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("addPropaganda");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            } else {
              let params = this.form;
              //params.applyId = "1829722136428707841";
              if (typeof this.form.addYear == "object") {
                params.addYear = new Date(this.form.addYear).getFullYear() + "";
              }
              params.applyType = this.applyType;
              putAction("/promotion/edit", params).then((res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success("编辑成功");
                  this.$emit("addPropaganda");
                } else {
                  this.$message.error(res.message);
                }
              });
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
    
    <style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.ipt-other {
  margin-left: 12px;
}
</style>
    